import { NodePositionChange, Node } from '@xyflow/react';
import { useCallback } from 'react';
import { RfNodeTextNode } from '../../canvas-types/nodeTypesData';
import { ObjectOperations } from '../objectOperations';
import { SweepCanvasRfNode } from '../../canvas-types/nodeTypesData';
import { CanvasEventType, CanvasMoveTextNodeEvent } from '../../canvas-types';
import { useSectionableNodeMoveEvent } from './useSectionableNodeMoveEvent';

export const useOnTextNodePositionChange = () => {
  const { createSectionableNodeMoveEvent } = useSectionableNodeMoveEvent();

  const onTextNodePositionChange = useCallback(
    ({
      nodeChange,
      node,
      nodeOperations,
      intersectionSectionNode,
      isResizing,
    }: {
      nodeChange: NodePositionChange;
      node: RfNodeTextNode;
      nodeOperations: ObjectOperations<SweepCanvasRfNode>;
      intersectionSectionNode: Node | null;
      isResizing: boolean;
    }): CanvasMoveTextNodeEvent | null => {
      nodeOperations.setObject(node.id, (node) => ({
        ...node,
        expandParent: !nodeChange.dragging && !isResizing,
      }));

      if (!nodeChange.dragging) {
        const moveEvent = createSectionableNodeMoveEvent({
          nodeChange,
          node,
          nodeOperations,
          intersectionSectionNode,
        });
        if (!moveEvent) {
          return null;
        }

        return {
          type: CanvasEventType.MoveTextNode,
          id: moveEvent.nodeId,
          xyPosition: moveEvent.xyPosition,
          parentId: moveEvent.parentId,
        };
      }
      return null;
    },
    [createSectionableNodeMoveEvent],
  );

  return {
    onTextNodePositionChange,
  };
};

